/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css'
import 'mapbox-gl/dist/mapbox-gl.js'
import { Plants } from '../../../@types/plants';
import { getplantsAllSimplePagination } from '../../../services/plantsService';
import Map, {FullscreenControl, GeolocateControl, NavigationControl, MapRef} from "react-map-gl"
import { getAlarmStatus } from '../../../services/alarm';
import { ModalPlant } from '../../components/modalPlant';
import './styles.css';
import useSize from '../../../hooks/useSize';
import { useQuery } from 'react-query';
import { AlarmStatus } from '../../../@types/alarmStatus';
import { Loading } from '../../components/Loadings/loading';

import styles from './maps.module.css';
import { MarkerMaps } from './components/MarkerMaps';
import { PaginationGlobal } from '../../components/PaginationGlobal';
import { CardPlant } from './components/CardPlant';
import { SearchInputV3 } from '../../components/SearchInputV3';
import { KTSVG } from '../../../../_metronic/helpers';

import { Virtuoso } from "react-virtuoso";
import { useInfiniteQuery } from "@tanstack/react-query";
import { LoadingSpan } from '../../components/Loadings/loadingSpan';
import { useAuth } from '../../../modules/auth';
import { PlantStatusTabs } from '../TablePlants/components/PlantStatusTabs';
import listLayoutStyles from '../../components/ListTableLayout/listTableLayout.module.css';
import toolbarStyles from '../../../components/OrderServiceChecklist/OrderServiceToolbar/orderServiceToolbar.module.css';

type Props = {
    page: number
}

interface ViewPort {
    latitude: number,
    longitude: number,
    zoom: number,
}

type Paginations = {
    page: number,
    limit: number,
    total: number,
    qtdPages: number
  }
  
  type SetPaginations = {
    start: number;
    end: number;
  }

  type PlantsPage = Plants[];

export function Maps({page}: Props) {
    const [filterAlarms, setFilterAlarms] = useState<number>(-1);
    const mapRef = useRef<MapRef>(null);
    const [myPlant, setMyPlant] = useState<string>("")
    const [showCreateAppModal, setShowCreateAppModal] = useState<boolean>(false);
    const [filterNamePlant, setFilterNamePlant] = useState<string>("");
    const containerRef = useRef<HTMLDivElement>(null);
    const modalRef = useRef<HTMLDivElement>(null);
    //const [tab, setTab] = useState<any>("LINHA");
    const user = useAuth();

    const [mapStyle, setMapStyle] = useState<any>({
        url: "mapbox://styles/lekkowilliamtorres/clu8gy4e8000e01qt6p0p28hi", 
        token: "pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdThnazlyZDBmcXEya29qMmZndGtmMmkifQ.kwHp_K24hVrkVHWqTE9yEQ"
    });
    
    const {width} = useSize();
    const [viewport, setViewport] = useState<ViewPort>({
        latitude: -15.7939,
        longitude: -47.8828,
        zoom: width < 1200 ? 2 : 4,
    });

    const [pagination, setPagination] = useState<Paginations>({
        page: 1,
        limit: user 
          && user.currentUser 
          && user.currentUser.role 
          && (user.currentUser.role.slug === "EMPRESA" 
            || user.currentUser.role.slug === "FILIAL")
          ? 50 
          : 15,
        total: 0,
        qtdPages: 1
      });
  
      const [qtd, setQtd] = useState<SetPaginations>({
        start: 0,
        end: user 
        && user.currentUser 
        && user.currentUser.role 
        && (user.currentUser.role.slug === "EMPRESA" 
          || user.currentUser.role.slug === "FILIAL")
        ? 50 
        : 15,
      });

    const {
        data: plants,
        isLoading: loadingPlants,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
      } = useInfiniteQuery<PlantsPage>({
        queryKey: ["getPlantsMaps", filterAlarms, filterNamePlant],
        queryFn: async ({ pageParam = 1 }) => {
          if (filterAlarms === -1) {
            const myPlants = await getplantsAllSimplePagination(
              `?limit=${pagination.limit}&page=${pageParam}&activeMark=true${
                filterNamePlant !== "" ? `&name=${filterNamePlant}` : ""
              }`
            );
      
            setPagination({
              ...pagination,
              qtdPages: myPlants.lastPage,
              total: myPlants.total,
            });
      
            return myPlants.data
          } else {
            const url = `?status=${
              filterAlarms !== -1 && filterAlarms !== -2 ? filterAlarms : ""
            }&alert=${filterAlarms === -2 ? true : false}&limit=${
              pagination.limit
            }&page=${pageParam}${
              filterNamePlant !== "" ? `&name=${filterNamePlant}` : ""
            }&activeMark=true`;
      
            const myPlants = await getplantsAllSimplePagination(url);
      
            setPagination({
              ...pagination,
              qtdPages: myPlants.lastPage,
              total: myPlants.total,
            });
      
            return myPlants.data
          }
        },
        getNextPageParam: (_, allPages) => {
          return allPages.length + 1;
        },
        initialPageParam: 1,
      });
      
      const visiblePlants = useMemo(() => {
        // Por enquanto, use todos; depois, filtre por bounds (veja solução 2)
        return plants?.pages.flat() ?? [];
      }, [plants]);
      
      
    const { 
        data: alarmStatus = {
          attention: 0,
          alarmNum: 0,
          normalNum: 0,
          offlineNum: 0,
          total: 0,
          info: 0,
          alertCount: 0
        }

    } = useQuery<AlarmStatus>(
        ["getSomeAlarmStatus"],
        async () => {
            const alarmStatusResult = await getAlarmStatus();
            return alarmStatusResult;
        },
        {
            onError: (error) => {
                console.log(error);
            },
        }
    )

    const handleLoadMore = useCallback(() => {
        if (hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

    useEffect(() => {
        if(page === 3){
            if(mapRef.current){
                mapRef.current.resize();
            }
        }
    }, [page, mapStyle]);


    useEffect(() => {
        const start = (pagination.page - 1) * pagination.limit + 1;
        const end = Math.min(pagination.page * pagination.limit, pagination.total);
    
        setQtd({start: start, end: end === 0 ? pagination.limit : end})
        
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [pagination.page]);


      useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
          if (
            (containerRef.current && 
            !containerRef.current.contains(event.target as Node)) || (modalRef.current && 
              !modalRef.current.contains(event.target as Node))
          ) {
            setMyPlant("");
          }
        }
      
        document.addEventListener("click", handleClickOutside);

        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
      }, []);
      
  return (
    <div
        className={`row g-xl-1 card py-5 px-5 ${styles.divGlobalMap}`} 
    >
        <div className={`${toolbarStyles.toolbarWrap} ${styles.mapToolbar}`}>
            {/* searchBox impede o input de quebrar linha abaixo do ícone no celular */}
            <div style={{width: '100%'}} className={`${toolbarStyles.searchBox} bg-gray-200 ${width < 1200 ? "p-1" : "p-4"} rounded`}>
                <SearchInputV3
                    className={`form-control form-control-sm ${listLayoutStyles.listSearch}`}
                    placeholder={"Buscar por nome"}
                    setMySearch={setFilterNamePlant}
                    setPagination={setPagination}
                    style={{width: '100%'}}
                />
            </div>

            <PlantStatusTabs
                alarmStatus={alarmStatus}
                filterAlarms={filterAlarms}
                onChange={setFilterAlarms}
            />
        </div>

        <div 
            className={`border border-gray-300 border-dashed rounded ${width < 1200 ? "p-1" : "p-2"} ${styles.responsiveHeight} card-body`}
        >
            {width > 1200 && (
                <div ref={containerRef}>
                    {plants && plants?.pages.flat().length > 0 ?
                     <Virtuoso
                        className={styles.divCardsMapsPlants}
                        totalCount={plants?.pages.flat().length ?? 0}
                        overscan={200} 
                        increaseViewportBy={{ top: 0, bottom: 1000 }}
                        endReached={() => {
                            if (hasNextPage && !isFetchingNextPage) {
                            fetchNextPage();
                            }
                        }}
                        itemContent={(index) => {
                            const allPlants = plants?.pages.flat() ?? [];
                            const plant = allPlants[index];
                            return plant ? (
                            <CardPlant
                                data={plant}
                                plantSelected={myPlant}
                                setShowCreateAppModal={setShowCreateAppModal}
                                setMyPlant={setMyPlant}
                                mapRef={mapRef}
                            />
                            ) : (
                                <LoadingSpan style={{marginLeft: '0.5rem'}} />
                            );
                        }}
                        components={{
                            Footer: () => hasNextPage ? (
                                <button
                                    type="button"
                                    className='btn btn-lg btn-light'
                                    onClick={handleLoadMore} 
                                    disabled={isFetchingNextPage || ((pagination.total === plants?.pages.flat().length) ? true : false) || plants?.pages.flat().length === 0}
                                    style={{ 
                                    width: '100%', 
                                    marginTop: '1rem',
                                    cursor: isFetchingNextPage ? 'not-allowed' : 'pointer'
                                    }}
                                >
                                    {isFetchingNextPage ? <LoadingSpan /> : 'Carregar mais'}
                                </button>
                                ) : null,
                        }}
                    /> : 
                        <div style={{width: '280px', display: 'flex', alignItems: 'center'}}>
                            <h3 className='card-title align-items-start flex-column'>
                                <span className='text-muted mt-1 fw-semibold fs-5'>Lista de usinas não encontradas!</span>
                            </h3>
                        </div>
                    }
                </div>
            )}
            
            {
                <Map
                    {...viewport}
                    key={mapStyle.url}
                    ref={mapRef}
                    mapLib={import('mapbox-gl')}
                    onMove={evt => setViewport(evt.viewState)}
                    mapboxAccessToken={mapStyle.token}
                    style={{width: "100%"}}
                    mapStyle={mapStyle.url}
                >    

                    {loadingPlants ? (
                        <div className={styles.divSpinnerTablePlants}>
                            <Loading myClass={`spinner-border ${styles.spinnerTablePlants}`}/>
                        </div>
                    ) : (
                    visiblePlants.map((project: Plants) => (
                        <MarkerMaps
                            key={project.id}
                            plant={project}
                            myPlantSelected={myPlant}
                            setMyPlant={setMyPlant}
                            setShowCreateAppModal={setShowCreateAppModal}
                            mapRef={mapRef}
                        />
                    ))
                    )}
  
                    <NavigationControl />
                    <GeolocateControl />
                    <FullscreenControl />

                    {/* <div style={{display: 'flex', position: "absolute", top: 10, left: 10, zIndex: 1000}}>
                        <button
                            onClick={() => {
                                setTab('LINHA')
                                setMapStyle({
                                    url: "mapbox://styles/lekkowilliamtorres/clu8gy4e8000e01qt6p0p28hi", 
                                    token: "pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdThnazlyZDBmcXEya29qMmZndGtmMmkifQ.kwHp_K24hVrkVHWqTE9yEQ"
                                })
                            }}
                            className={`btn btn-sm btn-light-primary ${tab === 'LINHA' ? 'active' : ''} ${styles.buttonSelectMapPrimary} text-active-white`}
                        >
                            <KTSVG path='/media/icons/duotune/maps/map001.svg' className='svg-icon-2x' />
                        </button>

                        <button
                            onClick={() => {
                                setTab('COLUNA')
                                setMapStyle({
                                    url: "mapbox://styles/lekkowilliamtorres/cmcyxa90s006f01qn168jebru", 
                                    token: "pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdTMxbXNxOTBxdXEycG90MzV5aDByYmgifQ.et3ajb0wLppFNRCo77qdHg"
                                })
                            }}
                            className={`btn btn-sm btn-light-primary ${tab === 'COLUNA' ? 'active' : ''} ${styles.buttonSelectMapSecondary} text-active-white`}
                        >
                            <KTSVG path='/media/icons/duotune/maps/map008.svg' className='svg-icon-2x' />
                        </button>
                    </div> */}
                </Map>
            }
        </div>

        {/* {width < 1200 &&
            <div className='card-footer pt-0 pb-1'>
                <PaginationGlobal 
                    pagination={pagination}
                    setPagination={setPagination}
                    qtd={qtd}
                />
            </div>
        } */}
        
        <ModalPlant 
            show={showCreateAppModal} 
            handleClose={() => {
                setMyPlant("")
                setShowCreateAppModal(false)
            }} 
            plant={myPlant}
            modalRef={modalRef}
        />
    </div>
  );
}